import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

// Institutional loading screen — fires on cross-page navigation (not the
// very first page load, which is covered by the app's own boot).
const FmsiPreloader = () => {
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);
  const lastPath = useRef(null);

  useEffect(() => {
    // StrictMode-safe: only fire when the path actually changes (skips initial
    // mount and double-invoked effects, which keep the same pathname).
    if (lastPath.current === null || lastPath.current === pathname) {
      lastPath.current = pathname;
      return undefined;
    }
    lastPath.current = pathname;
    setShow(true);
    const t = setTimeout(() => setShow(false), 700);
    return () => clearTimeout(t);
  }, [pathname]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="fmsi-preloader"
          data-testid="fmsi-preloader"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-0 z-[10000] flex items-center justify-center bg-white"
        >
          <div className="relative flex flex-col items-center">
            <div className="relative h-24 w-24">
              {/* Rotating accent ring */}
              <span className="absolute inset-0 rounded-full border-2 border-slate-100" />
              <motion.span
                className="absolute inset-0 rounded-full border-2 border-transparent border-t-[#E87A20] border-r-[#003366]"
                animate={{ rotate: 360 }}
                transition={{ duration: 0.9, ease: 'linear', repeat: Infinity }}
              />
              {/* FMSi mark */}
              <motion.div
                className="absolute inset-2 flex items-center justify-center"
                initial={{ scale: 0.9, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
              >
                <img src="/fmsi-icon.png" alt="Fortschritt Medical Supplies Inc." className="h-14 w-14 object-contain" />
              </motion.div>
            </div>
            <motion.p
              className="mt-6 font-display text-[10px] font-bold uppercase tracking-[0.4em] text-slate-400"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.15, duration: 0.4 }}
            >
              Fortschritt Medical Supplies
            </motion.p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FmsiPreloader;
